<template lang="html">
  <tr @click="go_to_recruiter">
    <td class="column-id link" @click="go_to_recruiter">
      {{ model.id }}
    </td>

    <td class="column-date link" @click="go_to_recruiter">
      {{ createdAt }}
    </td>

    <td class="column-name link" @click="go_to_recruiter">
      {{ !is_japan_locale ? [model.name, model.surname].join(' ') : [model.surname, model.name].join(' ') }}
    </td>

    <td class="column-is_active link" @click="go_to_recruiter">
      {{ is_active ? $tr('admin_console.company.manager.isActiveYes') : $tr('admin_console.company.manager.isActiveNo') }}
    </td>

    <td class="column-company link" @click="go_to_recruiter">
      {{ model.company ? model.company.name : '' }}
    </td>

    <td class="column-status link" @click="go_to_recruiter">
      {{ model.email }} <br/>
      {{ model.phone }}
    </td>

    <td class="column-stage link" @click="go_to_recruiter">
      <template v-for="role in model.roles">
        <span>{{ role.name }}</span>
        <br>
      </template>
    </td>

    <td class="column-vacancies link" @click="go_to_recruiter">{{ vacanciesNumber }} / {{ responsesNumber }}</span></td>

  </tr>
</template>

<script>
  import Moment from 'moment'

  import { STORE_PREFIX } from '../constants.js';

  export default {
    name: 'recruiter-row',

    components: {},

    props: {
      model: Object,
      companyId: null,
      is_japan_locale: Boolean
    },

    methods: {
      auth () {
        if (!this.user) {
          throw Error
        }

        this.$store.dispatch(STORE_PREFIX + 'admin/authUser', this.user)
          // .then(() => this.$router.replace('/'))
          .then(() => { window.location = '/' })
      },
      vacancyHref (id) {
        return '/admin/vacancies/' + id
      },

      go_to_recruiter() {
        this.$router.push(this.recruiter_route)
      }
    },

    computed: {
      createdAt () {
        return this.model.created_at
          ? Moment(this.model.created_at).format(this.dateFormat)
          : null
      },
      dateFormat() {
        return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
      },
      is_active() {
        if (!this.model || !this.model.last_action || !this.model.last_action.date) {
          return false
        }

        return Moment().diff(Moment(this.model.last_action.date, 'DD-MM-YYYY'), 'days') < 7
      },
      vacanciesNumber () {
        if (!this.model || !this.model.vacancies) {
          return 0
        }

        return this.model.vacancies.length
      },
      responsesNumber () {
        if (!this.model || !this.model.vacancies) {
          return 0
        }

        let result = 0
        for (let vacancy of this.model.vacancies) {
          result += vacancy.response_number
        }
        return result
      },

      recruiter_route() {
        return `/admin/company/${this.companyId}/recruiters/${this.model.id}`;
      }
    }
  }
</script>

<style lang="scss" scoped>

    .column-vacancies * {
        font-size: 12px;
    }

    .vcv-button {
        height: auto;
        padding: 1px 4px 1px 4px;
    }

    .vacancies-list {
        position: absolute;
        z-index: 9999;
        border: 1px solid grey;
        background: white;
        padding: 2px;

    }

    .vacancies-list * {
        transition-duration: 0s;
        transition-delay: 0s;
    }

</style>
